// API Configuration
// Uses environment variable if set, otherwise falls back to localhost for development
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

// API endpoints
export const API = {
    bible: (book: string, chapter?: number) =>
        chapter !== undefined
            ? `${API_BASE_URL}/bible?book=${book}&chapter=${chapter}`
            : `${API_BASE_URL}/bible?book=${book}`,

    chapters: (book: string) =>
        `${API_BASE_URL}/chapter?book=${book}`,

    greekGlossary: (word: string) =>
        `${API_BASE_URL}/greek_glossary?word=${encodeURIComponent(word)}`,

    hebrewGlossary: (word: string) =>
        `${API_BASE_URL}/hebrew_glossary?word=${encodeURIComponent(word)}`,

    greekByLexicalForm: (lexicalForm: string) =>
        `${API_BASE_URL}/greek_glossary/lexical?lexical_form=${encodeURIComponent(lexicalForm)}`,

    hebrewByLexicalForm: (lexicalForm: string) =>
        `${API_BASE_URL}/hebrew_glossary/lexical?lexical_form=${encodeURIComponent(lexicalForm)}`,

    word: `${API_BASE_URL}/word`,
    updateWord: `${API_BASE_URL}/word`, // Same endpoint, uses PUT method

    manuscript: (book: string, chapter: number) =>
        `${API_BASE_URL}/bible/manuscript?book=${book}&chapter=${chapter}`,

    // Audio endpoints - keyed by language + word (transliterated on server)
    audioUpload: (language: string, word: string) => `${API_BASE_URL}/audio/${language}/${encodeURIComponent(word)}`,
    audioGet: (language: string, word: string) => `${API_BASE_URL}/audio/${language}/${encodeURIComponent(word)}`,
    audioDelete: (language: string, word: string) => `${API_BASE_URL}/audio/${language}/${encodeURIComponent(word)}`,
    audioCheck: (language: string, word: string) => `${API_BASE_URL}/audio/${language}/${encodeURIComponent(word)}`,

    // Demo endpoints (no auth required)
    demoBible: (book: string, chapter: number) => `${API_BASE_URL}/demo/bible?book=${book}&chapter=${chapter}`,

    // Auth endpoints
    authLogin: `${API_BASE_URL}/auth/login`,
    authSignup: `${API_BASE_URL}/auth/signup`,
    authRefresh: `${API_BASE_URL}/auth/refresh`,
    authLogout: `${API_BASE_URL}/auth/logout`,
    authMe: `${API_BASE_URL}/auth/me`,
    authGoogle: `${API_BASE_URL}/auth/google`,
};
